import { gql } from "@apollo/client"
import { useQuery } from "@apollo/client/react"
import { GraduationCap } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"

const VERSION_QUERY = gql`
  query Version {
    version
  }
`

export default function HomePage() {
  const { data, loading, error } = useQuery<{ version: string }>(VERSION_QUERY)

  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="mb-2 flex size-10 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <GraduationCap className="size-5" />
          </div>
          <CardTitle>I Know School</CardTitle>
          <CardDescription>Rails + SQLite + GraphQL + React + Tailwind</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {loading && "Checking the API…"}
            {error && `API error: ${error.message}`}
            {data && `API says: ${data.version}`}
          </p>
          <Button>Get started</Button>
        </CardContent>
      </Card>
    </main>
  )
}
